export default defineNuxtPlugin((nuxtApp) => {
  const { $logger } = useNuxtApp();

  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    $logger.fatalException({ label: "Vue error", info }, err);
  };

  // eslint-disable-next-line unicorn/prefer-add-event-listener
  window.onerror = (message, source, lineno, colno, error) => {
    if (message === "Script error.") return;

    $logger.fatalException({ label: "Window error" }, { message, source, lineno, colno, error });
  };

  window.onunhandledrejection = (event) => {
    $logger.fatalException({ label: "Unhandled rejection" }, event);
  };
});
